import * as constants from "../constants/index";
import environments from "../environments";

export const fetchItems = (callback) => {
  const endpoint = `${environments.API_BASE_URI}/process_major_classes`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.PROCESS_MAJOR_CLASS_BEGIN_FETCH_ITEMS,
        };
      },
      success: (response) => {
        if (callback !== undefined) {
          callback(response);
        }

        return {
          type: constants.PROCESS_MAJOR_CLASS_END_FETCH_ITEMS,
          payload: response.process_major_classes,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const changeSearchText = (text) => {
  return {
    type: constants.PROCESS_MAJOR_CLASS_CHANGE_SEARCH_TEXT,
    payload: text,
  };
};

export const searchItems = (text, callback) => {
  let endpoint = `${environments.API_BASE_URI}/process_major_classes`;

  if (text && text.length > 0) {
    const params = new URLSearchParams();
    params.set("text", text);
    endpoint = `${endpoint}?${params.toString()}`;
  }

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.PROCESS_MAJOR_CLASS_BEGIN_SEARCH_ITEMS,
        };
      },
      success: (response) => {
        if (callback !== undefined) {
          callback(response);
        }

        return {
          type: constants.PROCESS_MAJOR_CLASS_END_SEARCH_ITEMS,
          payload: response.process_major_classes,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const fetchItem = (id, callback, failedCallback) => {
  return {
    type: constants.APP_CALL_API,
    endpoint: `${environments.API_BASE_URI}/process_major_classes/${id}`,
    method: "GET",
    callbacks: {
      success: (response) => {
        callback();

        return {
          type: constants.PROCESS_MAJOR_CLASS_END_FETCH_ITEM,
          payload: response,
        };
      },
      error: (response) => {
        if (failedCallback !== undefined) {
          failedCallback();
        }

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const createItem = (data, handleSuccess, handleCancel) => {
  return (dispatch, getState) => {
    const { process_major_class_name, schedule_mapping_flg, inspection_flg, sort } = data;
    const action = {
      type: constants.APP_CALL_API,
      endpoint: `${environments.API_BASE_URI}/process_major_classes/create`,
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        process_major_class_name,
        schedule_mapping_flg,
        inspection_flg,
        sort,
      }),
      callbacks: {
        success: (response) => {
          handleSuccess();

          return {
            type: constants.PROCESS_MAJOR_CLASS_END_CREATE_ITEM,
            payload: response,
          };
        },
        error: (response) => {
          return {
            type: constants.APP_SHOW_ERROR,
            payload: response,
            error: true,
          };
        },
      },
    };

    // 作業大分類名の重複チェック（重複している場合はアラート＆登録中止）
    const state = getState();
    const items = state.process_major_class.masterItems;

    if (items.some((item) => item.process_major_class_name === process_major_class_name)) {
      action.meta = {
        alert: {
          messages: ["msg_already", "process_major_class_name", "msg_exists"],
          okHandler: handleCancel,
        },
      };
    }

    dispatch(action);
  };
};

export const updateItem = (data, handleSuccess, handleCancel, failedCallback) => {
  return (dispatch, getState) => {
    const { process_major_class_id, process_major_class_name, schedule_mapping_flg, inspection_flg, sort, timestamp } =
      data;
    const action = {
      type: constants.APP_CALL_API,
      endpoint: `${environments.API_BASE_URI}/process_major_classes/update/${process_major_class_id}`,
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify({
        process_major_class_name,
        schedule_mapping_flg,
        inspection_flg,
        sort,
        timestamp,
      }),
      callbacks: {
        success: (response) => {
          handleSuccess();

          return {
            type: constants.PROCESS_MAJOR_CLASS_END_UPDATE_ITEM,
            payload: response,
          };
        },
        error: (response) => {
          if (failedCallback !== undefined) {
            failedCallback(response);
          }

          return {
            type: constants.APP_SHOW_ERROR,
            payload: response,
            error: true,
          };
        },
      },
    };

    // 作業大分類の重複チェック（重複している場合はアラート＆登録中止）
    const state = getState();
    const items = state.process_major_class.masterItems;

    items.some((item) => {
      if (
        item.process_major_class_id !== process_major_class_id &&
        item.process_major_class_name === process_major_class_name
      ) {
        const merge_target_id = item.process_major_class_id;
        action.meta = {
          confirm: {
            messages: ["msg_already", "process_major_class_name", "msg_exists", "msg_merge"],
            cancelHandler: handleCancel,
          },
        };
        action.endpoint = `${environments.API_BASE_URI}/process_major_classes/merge/${process_major_class_id}`;
        action.body = JSON.stringify({
          merge_target_id,
          timestamp,
        });
        action.callbacks.success = (response) => {
          handleSuccess();

          return {
            type: constants.PROCESS_MAJOR_CLASS_END_MERGE_ITEM,
            payload: response,
          };
        };

        return true;
      }
    });

    dispatch(action);
  };
};

export const deleteItem = (id, name) => {
  return {
    type: constants.APP_CALL_API,
    endpoint: `${environments.API_BASE_URI}/process_major_classes/delete/${id}`,
    method: "POST",
    callbacks: {
      begin: () => {
        return {
          type: constants.PROCESS_MAJOR_CLASS_BEGIN_DELETE_ITEM,
        };
      },
      success: (response) => {
        return {
          type: constants.PROCESS_MAJOR_CLASS_END_DELETE_ITEM,
          payload: {
            id,
            ...response,
          },
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
    meta: {
      confirm: {
        messages: [name, "msg_deleted"],
      },
    },
  };
};
